import { render, staticRenderFns } from "./TraverGuideConfig.vue?vue&type=template&id=5dacbc3b"
import script from "./TraverGuideConfig.vue?vue&type=script&lang=js"
export * from "./TraverGuideConfig.vue?vue&type=script&lang=js"
import style0 from "./TraverGuideConfig.vue?vue&type=style&index=0&id=5dacbc3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports